/**
 * UN IDENTIFICADOR ÚNICO, HAYA O NO CONTEXTO SEGURO.
 *
 * `crypto.randomUUID()` solo existe en contextos seguros: HTTPS, o localhost.
 * El servidor de pruebas sirve por `http://` sobre una IP, así que ahí la
 * función NO EXISTE y revienta con «crypto.randomUUID is not a function» —que
 * es lo que vio Johan al intentar subir una foto—.
 *
 * Es un fallo que no aparece en producción, porque allí sí hay HTTPS. Por eso
 * es de los peores: se cuela hasta que alguien prueba en el sitio de pruebas y
 * parece que la funcionalidad está rota cuando lo que falta es el candado.
 *
 * Aquí se usa la de verdad cuando está, y si no se arma uno equivalente con
 * `getRandomValues` —que sí existe en contexto inseguro— siguiendo la forma de
 * un UUID v4. Y si ni eso, se cae a `Math.random`, que para nombrar un archivo
 * en una carpeta propia es suficiente: no es un secreto, es un nombre.
 */
export function identificadorUnico(): string {
  const c = globalThis.crypto as Crypto | undefined

  if (c && typeof c.randomUUID === 'function') return c.randomUUID()

  if (c && typeof c.getRandomValues === 'function') {
    const b = c.getRandomValues(new Uint8Array(16))
    // La versión (4) y la variante, como manda el formato.
    b[6] = (b[6] & 0x0f) | 0x40
    b[8] = (b[8] & 0x3f) | 0x80
    const hex = [...b].map((n) => n.toString(16).padStart(2, '0')).join('')
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}`
}
